import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  ACTIVITY_MY: 'activity-my',
  ACTIVITY_PIDUECI: 'activity-pidueci'
}

const routes = [
  {
    path: 'activity/my',
    name: ROUTES.ACTIVITY_MY,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['tasks_task_summary'],
      requiresAuth: true
    },
    component: () => import('./MyActivityPage.vue')
  },
  {
    path: 'activity/pidueci',
    name: ROUTES.ACTIVITY_PIDUECI,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['tasks_task_summary'],
      requiresAuth: true
    },
    component: () => import('./PidueciActivityPage.vue')
  }
]

export { routes, ROUTES }
